<template>
    <div>
        <section id="content">
            <div class="container">
                <div class="block" id="contentElement">
                    <!-- >>> BreadCrumbs - Row ----------------------------- -->
                    <div class="row">
                        <sdr-breadcrumbs active_item="third" module="rebooking"></sdr-breadcrumbs>
                    </div>
                    <!-- <<< BreadCrumbs - Row ----------------------------- -->


                    <!-- >>> 'FlightSearchResults' - Row ------------------- -->
                    <div class="row">
                        <!-- >>> Left Side: 'SearchResults' -->
                        <div class="col-sm-8 col-md-9">
                            <div class="container shortcode travel-ideas">
                                <h1 class="idea-title" style="margin-bottom:30px;"><span class="index"><i class="soap-icon-arrow-right circle"></i></span>{{ pleaseselectflightheadline[getCurrentLocale] }}</h1>
                            </div>


                            <!-- >>> SearchResults Tabs -->
                            <div class="tab-container style1">
                                <!-- >>> TabHeader:  -->
                                <ul class="tabs full-width srvcs">
                                    <li v-bind:class="{ active_rebooking: isActive === 'outwardsearchresults' }" v-if="get_RebookingUsersSearchDataFlightSearch.departsAfter !== null">
                                        <a href="#outwardsearchresults" data-toggle="tab" @click.prevent="isActive ='outwardsearchresults'">{{ departureflightlist[getCurrentLocale] }} </a>
                                    </li>
                                    <li v-bind:class="{ active_rebooking: isActive === 'returnsearchresults' }" v-if="get_RebookingUsersSearchDataFlightSearch.returnsAfter !== null">
                                        <a href="#returnsearchresults" data-toggle="tab" @click.prevent="isActive ='returnsearchresults'">{{ returnflightlist[getCurrentLocale] }}</a>
                                    </li>
                                </ul>
                                <!-- <<< TabHeader:  -->


                                <!-- >>> TabContent: Out/Ret Results -->
                                <div class="tab-content">
                                    <!-- >>> Tab: 'outwardsearchresults' -->
                                    <div class="tab-pane fade" v-bind:class="{ in: get_RebookingUsersSearchDataFlightSearch.departsAfter !== null, active: get_RebookingUsersSearchDataFlightSearch.departsAfter !== null }" id="outwardsearchresults">
                                        <div class="pricing-table">
                                            <div class="header clearfix" style="border-bottom: 0px;">
                                                <i class="soap-icon-plane-right circle takeoff-effect yellow-color"></i>
                                                <h3 style="padding-top: 5px;" v-if="filterOutwardOnly(get_RebookingFlightSearchResults).length !== 0">{{ getRebookingDepArprtName + ' - ' + getRebookingDesArprtName }}</h3>
                                                <h3 style="padding-top: 5px;" v-if="filterOutwardOnly(get_RebookingFlightSearchResults).length === 0">{{ getRebookingDepArprtName + ' - ' + getRebookingDesArprtName }} - {{ noresultsout[getCurrentLocale] }}</h3>
                                            </div>
                                        </div>

                                        <!-- >>> Outward Search Results Loop -->
                                        <div class="row image-box" v-for="(flight) in filterOutwardOnly(get_RebookingFlightSearchResults)" v-bind:key="flight.id">
                                            <div class="col-sm-12 col-md-12">
                                                <div class="flight-list listing-style3 flight">
                                                    <article class="box div_hover">
                                                        <!-- >>> The Logo -->
                                                        <figure class="col-xs-3 col-sm-2">
                                                            <span><img alt src="/res/images/logo-centered3.png"></span>
                                                            <span class="discount" v-show="get_RebookingFlightIdSelectedOutward === flight.id" >
                                                                <span class="discount-text">{{ soldoutsrvcs[getCurrentLocale] }}</span>
                                                            </span> <!-- >>> 'Added' Ribbon -->
                                                        </figure>
                                                        <!-- <<< The Logo -->
                                                        <sdr-rebooking-flight :flight="flight" flightdirection="outward"></sdr-rebooking-flight>
                                                    </article>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <<< Outward Search Results Loop -->
                                    </div>
                                    <!-- <<< Tab: 'outwardsearchresults' -->



                                    <!-- >>> Tab: 'returnsearchresults' -->
                                    <div class="tab-pane fade" v-bind:class="{ in: get_RebookingUsersSearchDataFlightSearch.returnsAfter !== null && get_RebookingUsersSearchDataFlightSearch.departsAfter === null, active: get_RebookingUsersSearchDataFlightSearch.returnsAfter !== null && get_RebookingUsersSearchDataFlightSearch.departsAfter === null }" id="returnsearchresults">
                                        <div class="pricing-table">
                                            <div class="header clearfix" style="border-bottom: 0px;">
                                                <i class="soap-icon-plane-right takeoff-effect1 circle yellow-color"></i>
                                                <h3 style="padding-top: 5px;" v-if="filterReturnOnly(get_RebookingFlightSearchResults).length !== 0">{{ getRebookingDesArprtName + ' - ' + getRebookingDepArprtName }}</h3>
                                                <h3 style="padding-top: 5px;" v-if="filterReturnOnly(get_RebookingFlightSearchResults).length === 0">{{ getRebookingDesArprtName + ' - ' + getRebookingDepArprtName }} - {{ noresultsret[getCurrentLocale] }}</h3>
                                            </div>
                                        </div>

                                        <!-- >>> Return Search Results Loop -->
                                        <div class="row image-box" v-for="(flight) in filterReturnOnly(get_RebookingFlightSearchResults)" v-bind:key="flight.id">
                                            <div class="col-sm-12 col-md-12">
                                                <div class="flight-list listing-style3 flight">
                                                    <article class="box div_hover">
                                                        <!-- >>> The Logo -->
                                                        <figure class="col-xs-3 col-sm-2">
                                                            <span><img alt src="/res/images/logo-centered3.png"></span>
                                                            <span class="discount" v-show="get_RebookingFlightIdSelectedReturn === flight.id">
                                                                <span class="discount-text">{{ soldoutsrvcs[getCurrentLocale] }}</span>
                                                            </span> <!-- >>> 'Added' Ribbon -->
                                                        </figure>
                                                        <!-- <<< The Logo -->
                                                        <sdr-rebooking-flight :flight="flight" flightdirection="return"></sdr-rebooking-flight>
                                                    </article>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <<< Return Search Results Loop -->
                                    </div>
                                    <!-- <<< Tab: 'returnsearchresults' -->
                                </div>
                                <!-- <<< TabContent: Out/Ret Results -->
                            </div>
                            <!-- <<< SearchResults Tabs -->



                            <br />
                            <!-- >>> ProceedButton(s) -->
                            <!-- >>> Variante 1: Normal, RoundTrip, Flights in both Directions -->
                            <div v-if="get_RebookingUsersSearchDataFlightSearch.roundtrip === true && (filterOutwardOnly(get_RebookingFlightSearchResults).length !== 0 && filterReturnOnly(get_RebookingFlightSearchResults).length !== 0)">
                                <button type="submit" class="btn-large icon-check uppercase full-width  sundairrebooking icon-check4" v-if="get_FlagRebookingOutwardFlightSelected === true && get_FlagRebookingReturnFlightSelected === true" @click.prevent="onClick_ProceedToPayment()">{{ proceed[getCurrentLocale] }}</button>
                                <a class="button btn-large uppercase full-width silver" v-if="get_FlagRebookingOutwardFlightSelected !== true || get_FlagRebookingReturnFlightSelected !== true">{{ proceed[getCurrentLocale] }} </a>
                            </div>

                            <!-- >>> Variante 2: Normal, RoundTrip, No Flights on Outward OR Return -->
                            <div v-if="get_RebookingUsersSearchDataFlightSearch.roundtrip === true && (filterOutwardOnly(get_RebookingFlightSearchResults).length === 0 || filterReturnOnly(get_RebookingFlightSearchResults).length === 0)">
                                <!-- <button type="submit" class="btn-large icon-check uppercase full-width  sundairrebooking icon-check4" v-if="get_FlagRebookingOutwardFlightSelected === true" @click.prevent="onClick_ProceedToPayment()">{{ proceed[getCurrentLocale] }}</button> -->
                                <a class="button btn-large uppercase full-width silver" v-if="get_FlagRebookingOutwardFlightSelected !== true">{{ proceed[getCurrentLocale] }} </a>
                            </div>

                            <!-- >>> Variante 3: Outward Only -->
                            <div v-if="get_RebookingUsersSearchDataFlightSearch.roundtrip !== true && get_RebookingUsersSearchDataFlightSearch.departsAfter !== null">
                                <button type="submit" class="btn-large icon-check uppercase full-width  sundairrebooking icon-check4" v-if="get_FlagRebookingOutwardFlightSelected === true" @click.prevent="onClick_ProceedToPayment()">{{ proceed[getCurrentLocale] }}</button>
                                <a class="button btn-large uppercase full-width silver" v-if="get_FlagRebookingOutwardFlightSelected !== true">{{ proceed[getCurrentLocale] }} </a>
                            </div>

                            <!-- >>> Variante 4: Return Only -->
                            <div v-if="get_RebookingUsersSearchDataFlightSearch.roundtrip !== true && get_RebookingUsersSearchDataFlightSearch.returnsAfter !== null">
                                <button type="submit" class="btn-large icon-check uppercase full-width sundairrebooking icon-check4" v-if="get_FlagRebookingReturnFlightSelected === true" @click.prevent="onClick_ProceedToPayment()">{{ proceed[getCurrentLocale] }}</button>
                                <a class="button btn-large uppercase full-width silver" v-if="get_FlagRebookingReturnFlightSelected !== true">{{ proceed[getCurrentLocale] }} </a>
                            </div>
                            <!-- <<< ProceedButton(s) -->
                        </div>
                        <!-- <<< Left Side: 'SearchResults' -->



                        <!-- >>> Right Side: Sidebar -->
                        <div class="sidebar col-sms-6 col-sm-4 col-md-3 topDistance" style="">
                            <h2>&nbsp;</h2>
                            <h4 class="search-results-title"><i class="soap-icon-search"></i><b>{{ get_RebookingFlightSearchResults.length }}</b> {{ resultsshown[getCurrentLocale] }}.</h4>

                            <!-- >>> VueCmp - 'sdr-shared-cart', 'Shared Cart' -->
                            <!-- <sdr-shared-cart :modulo="modulo"></sdr-shared-cart> -->
                            <!-- <<< VueCmp - 'sdr-shared-cart', 'Shared Cart' -->
                        </div>
                        <!-- <<< Right Side: Sidebar -->
                    </div>
                    <!-- <<< 'FlightSearchResults' - Row ------------------- -->
                </div>
            </div>
        </section>



        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <modal name="rebooking-error-modal"
                transition="nice-modal-fade"
                classes="demo-modal-class"
                :min-width="100"
                :min-height="100"
                :pivot-y="0.5"
                :adaptive="true"
                :scrollable="true"
                :reset="true"
                width="500px"
                height="auto"
                @before-open="beforeOpen"
                @opened="opened"
                @closed="closed"
                @before-close="beforeClose">
                <div class="rebooking-error-modal-content" style="border: 2px solid red;">
                    <section id="content" style="padding:20px; min-height: 100px;">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="container shortcode travel-ideas">
                                    <h3 class="idea-title" style="margin-bottom:10px;"><span class="index"><i class="soap-icon-notice circle"></i></span>{{ modal_headline_rebooking_error[getCurrentLocale] }}</h3>
                                </div>

                                <div>
                                    <br />
                                    <h4 v-html="modal_content_rebooking_error[getCurrentLocale]"></h4>
                                </div>
                            </div>
                        </div>
                    </section>
                    <button type="button" class="btn-large full-width totalbutton sundair" style="cursor: initial; outline: none !important; outline-style: none !important; margin-bottom: 0px;" @click.prevent="onClick_CloseModal()"> {{ closemodal[getCurrentLocale] }}</button>
                </div>
        </modal>



        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <modal name="noexistingflights-error-modal"
                transition="nice-modal-fade"
                classes="demo-modal-class"
                :min-width="100"
                :min-height="100"
                :pivot-y="0.5"
                :adaptive="true"
                :scrollable="true"
                :reset="true"
                width="500px"
                height="auto"
                @before-open="beforeOpen"
                @opened="opened"
                @closed="closed"
                @before-close="beforeClose">
                <div class="booking-error-modal-content" style="border: 2px solid red;">
                    <section id="content" style="padding:20px; min-height: 100px;">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="container shortcode travel-ideas">
                                    <h3 class="idea-title" style="margin-bottom:10px;"><span class="index"><i class="soap-icon-notice circle"></i></span>{{ modal_headline_rebooking_error2[getCurrentLocale] }}</h3>
                                </div>

                                <div>
                                    <br />
                                    <h4 v-html="modal_content_rebooking_error2[getCurrentLocale]"></h4>
                                </div>
                            </div>
                        </div>
                    </section>
                    <button type="button" class="btn-large full-width totalbutton sundair" style="cursor: initial; outline: none !important; outline-style: none !important; margin-bottom: 0px;" @click.prevent="onClick_CloseModal()"> {{ closemodal[getCurrentLocale] }}</button>
                </div>
        </modal>
    </div>
</template>

<script>
    import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs.vue';
    import Flight from './Flight.vue';

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo', 'mode'], // mode: 'overview', 'rebookingpassengers'
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-breadcrumbs': Breadcrumbs,
            'sdr-rebooking-flight': Flight,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                // ----------------------------------------
                isActive: 'outwardsearchresults', // outwardsearchresults, returnsearchresults

                // ----------------------------------------
                pleaseselectflightheadline: {
                    en: 'Step 1: Please select your new Flight(s).',
                    de: 'Schritt 1: Bitte wählen Sie Ihren neuen Flug/Flüge aus.'
                },
                // ----------------------------------------
                departureflightlist: {
                    en: 'Departure Flight List',
                    de: 'Hinflüge',
                },
                returnflightlist: {
                    en: 'Return Flight List',
                    de: 'Rückflüge',
                },
                // ----------------------------------------
                resultsshown: {
                    en: 'flights found',
                    de: 'Flüge gefunden'
                },
                // ----------------------------------------
                noresultsout: {
                    en: 'Attention: No more outward flights found!',
                    de: 'Achtung: Keine Hinflüge mehr gefunden!',
                },
                noresultsret: {
                    en: 'Attention: No more return flights found!',
                    de: 'Achtung: Keine Rückflüge mehr gefunden!',
                },
                soldoutsrvcs: {
                    en: 'Your Flight!',
                    de: 'Ihr Flug!',
                },
                proceed: {
                    en: 'CONTINUE TO DETERMINE PRICES',
                    de: 'WEITER ZU PREISE BESTIMMEN',
                },
                // ----------------------------------------
                modal_headline_rebooking_error: {
                    en: 'Attention: No more services',
                    de: 'Achtung: Keine Services mehr',
                },
                modal_content_rebooking_error: {
                    en: 'Unfortunately the service you originally booked is no longer available on your selected flight.<br />This means that we cannot rebook your flight completely.<br /><br />Please select another flight.',
                    de: 'Leider ist der von Ihnen ursprünglich gebuchte Service auf Ihrem ausgewählten Flug nicht mehr verfügbar.<br />So können wir Ihren Flug nicht vollständig umbuchen.<br /><br />Bitte wählen Sie einen anderen Flug aus.',
                },
                // ----------------------------------------
                modal_headline_rebooking_error2: {
                    en: 'Attention: No Flights anymore',
                    de: 'Achtung: Keine Flüge mehr',
                },
                modal_content_rebooking_error2: {
                    en: 'Dear customer, for your search request outbound or return flights are already fully booked.<br /><br />Rebooking is not possible in this way.',
                    de: 'Lieber Kunde, für Ihre Suchanfrage sind bereits Hin- oder Rückflüge ausgebucht.<br /><br />Eine Umbuchungs ist so nicht möglich.',
                },

                closemodal: {
                    en: 'Close',
                    de: 'Schliessen',
                },
                // ----------------------------------------
                seatnotconfirmed: {
                    en: 'ATTENTION: Seats could not be rebooked!',
                    de: 'ACHTUNG: Sitze konnten nicht umgebucht werden!',
                },
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'get_RebookingUsersSearchDataFlightSearch',
                'get_RebookingFlightSearchResults',
                'getRebookingDepArprtName',
                'getRebookingDesArprtName',
                'getRebookingDepArprtCode',
                'getRebookingDesArprtCode',
                'get_RebookingFlightIdSelectedOutward',
                'get_RebookingFlightIdSelectedReturn',
                'get_FlagRebookingOutwardFlightSelected',
                'get_FlagRebookingReturnFlightSelected',
                'get_RebookingUsersSearchDataBookingno',
                'getRebookingIdTicketOutwards',
                'getRebookingIdTicketReturn',
                'get_RebookingPriceIdSelectedOutward',
                'get_RebookingPriceIdSelectedReturn',
                // >>> ------------------------------------
                'get_RebookingGetRebookingKeyResults',
                'get_RebookingGetBookingResults',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note: Catch Event 'readytoshowrebookingspayment' ('Call done ...').
        * Note:
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> rebooking/flightsearchresults/FlightSearchResults.vue >>> created');
            eventBus.$on('readytoshowrebookingspayment', this.onEmit_ReadyToShowRebookingsPayment);
            eventBus.$on('errorrebookingnoservicesanymore', this.onEmit_ErrorRebookingNoServicesAnymore);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note: Set 'isActive' here. ( 'outwardsearchresults', 'returnsearchresults' )
        *
        */
        mounted: function() {

            let me = this;


            me.$toc('>>> rebooking/flightsearchresults/FlightSearchResults.vue >>> mounted');
            if (this.get_RebookingUsersSearchDataFlightSearch.departsAfter !== null) {
                this.isActive = 'outwardsearchresults';
            }
            if (this.get_RebookingUsersSearchDataFlightSearch.returnsAfter !== null && this.get_RebookingUsersSearchDataFlightSearch.departsAfter === null) {
                this.isActive = 'returnsearchresults';
            }

            this.check_NoReturnFlightsOnRoundtrip(); // #657

        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> rebooking/flightsearchresults/FlightSearchResults.vue >>> beforeDestroy');
            eventBus.$off('readytoshowrebookingspayment', this.onEmit_ReadyToShowRebookingsPayment);
            eventBus.$off('errorrebookingnoservicesanymore', this.onEmit_ErrorRebookingNoServicesAnymore);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_getRebookingKey',
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_ProceedToPayment()
            *
            * Desc:
            * Note:
            *
            */
            onClick_ProceedToPayment: function() {

                var me = this,
                    params = {};



                me.$toc('>>> rebooking/flightsearchresults/FlightSearchResults.vue >>> onClick_ProceedToPayment');
                params = this.build_Params_Call_geRebookingKey();
                this.actn_call_getRebookingKey(params);

            }, // eo function onClick_ProceedToPayment()


            /*******************************************************************
            * onClick_CloseModal()
            *
            * Desc:
            * Note: Method Name is misleading. Only for reasons of equality.
            *
            */
            onClick_CloseModal: function() {

                var me = this;


                me.$modal.hide('rebooking-error-modal');
                me.$modal.hide('noexistingflights-error-modal');

            }, // eo function onClick_CloseModal()


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onEmit_ReadyToShowRebookingsPayment()
            *
            * Desc: Handle
            * Note:
            *
            */
            onEmit_ReadyToShowRebookingsPayment: function() {

                let me = this,
                    found = 0,
                    options = {};


                me.$toc('>>> rebooking/flightsearchresults/FlightSearchResults.vue >>> onEmit_ReadyToShowRebookingsPayment');
                // >>> Scroll Options ------------------------------------------
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };


                // >>> Check for Seats -----------------------------------------
                setTimeout(function() {
                    me.get_RebookingGetRebookingKeyResults.tickets.forEach((ticket, i) => {
                        if (found === 0) {
                            if (ticket.seatServices.length > 0) {
                                if (ticket.seatServices[0].status !== 'CONFIRMED') {
                                    me.$toasted.global.sdr_app_error({
                                        message: me.seatnotconfirmed[me.getCurrentLocale],
                                    });
                                    found = found + 1;
                                }
                            }
                        }
                    });
                }, 600);


                // >>> Push ----------------------------------------------------
                // me.$router.push({ path: '/payment/' + me.modulo });
                me.$router.push({ path: '/ownprice/' + me.modulo });

                setTimeout(function() {
                    me.$scrollTo('#scrollPointTop', 200, options);
                }, 300);

            }, // eo function onEmit_ReadyToShowRebookingsPayment()


            /*******************************************************************
            * onEmit_ErrorRebookingNoServicesAnymore()
            *
            * Desc: Handle
            * Note:
            *
            */
            onEmit_ErrorRebookingNoServicesAnymore: function() {

                var me = this;


                me.$toc('>>> rebooking/flightsearchresults/FlightSearchResults.vue >>> onEmit_ErrorRebookingNoServicesAnymore');
                me.$modal.show('rebooking-error-modal');

            }, // eo function onEmit_ErrorRebookingNoServicesAnymore()


            /*******************************************************************
            * check_NoReturnFlightsOnRoundtrip()
            *
            * Desc: Check if Roundtrip has no Ret Flights. Show Message.
            * Note:
            *
            */
            check_NoReturnFlightsOnRoundtrip: function() {

                var me = this;


                me.$toc('>>> rebooking/flightsearchresults/FlightSearchResults.vue >>> check_NoReturnFlightsOnRoundtrip');
                if (this.isUser_AllowedToGoOn() === false) {
                    me.$modal.show('noexistingflights-error-modal');
                }

            }, // eo function check_NoReturnFlightsOnRoundtrip()



            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * isUser_AllowedToGoOn()
            *
            * Desc: Dont go on ... if there are no longer Flight ins one Direction.
            * Note:
            *
            */
            isUser_AllowedToGoOn: function () {

                let me = this,
                    isUser_AllowedToGoOn = true;


                me.$toc('>>> rebooking/flightsearchresults/FlightSearchResults.vue >>> isUser_AllowedToGoOn');
                if ((this.get_RebookingGetBookingResults.inboundFlights || []).length > 0 && (this.get_RebookingGetBookingResults.outwardFlights || []).length > 0 && this.get_RebookingUsersSearchDataFlightSearch.departsAfter !== null && this.get_RebookingUsersSearchDataFlightSearch.returnsAfter !== null) {
                    if (this.filterOutwardOnly(this.get_RebookingFlightSearchResults).length === 0 || this.filterReturnOnly(this.get_RebookingFlightSearchResults).length === 0) {
                        isUser_AllowedToGoOn = false;
                    }
                }


                if (isUser_AllowedToGoOn) {
                    if (this.get_RebookingUsersSearchDataFlightSearch.departsAfter !== null && this.filterOutwardOnly(this.get_RebookingFlightSearchResults).length === 0) {
                        isUser_AllowedToGoOn = false; // wants only outward BUT no Flights anymore
                    }
                }


                if (isUser_AllowedToGoOn) {
                    if (this.get_RebookingUsersSearchDataFlightSearch.returnsAfter !== null && this.filterReturnOnly(this.get_RebookingFlightSearchResults).length === 0) {
                        isUser_AllowedToGoOn = false; // wants only return BUT no Flights anymore
                    }
                }



                return isUser_AllowedToGoOn;

            }, // eo function isUser_AllowedToGoOn()


            /*******************************************************************
            * filterOutwardOnly()
            *
            * Desc:
            *
            * @param {Object} flights (All Search Results Object)
            * @return {string}
            */
            filterOutwardOnly: function (flights) {

                let me = this,
                    refCode = me.getRebookingDepArprtCode;


                me.$toc('>>> rebooking/flightsearchresults/FlightSearchResults.vue >>> filterOutwardOnly');
                if (!Array.isArray(flights)) {
                    return [];
                }
                if (!refCode) {
                    return flights;
                }

                return flights.filter(function (flight) {
                    return flight.depArprt && flight.depArprt.i === refCode;
                });

            }, // eo function filterOutwardOnly()


            /*******************************************************************
            * filterReturnOnly()
            *
            * Desc:
            *
            * @param {Object} flights (All Search Results Object)
            * @return {string}
            */
            filterReturnOnly: function (flights) {

                let me = this,
                    refCode = me.getRebookingDepArprtCode;


                me.$toc('>>> rebooking/flightsearchresults/FlightSearchResults.vue >>> filterReturnOnly');
                if (!Array.isArray(flights)) {
                    return [];
                }
                if (!refCode) {
                    return flights;
                }

                return flights.filter(function (flight) {
                    return flight.depArprt && flight.depArprt.i !== refCode;
                });

            }, // eo function filterReturnOnly()


            /*******************************************************************
            * build_Params_Call_geRebookingKey()
            *
            * Desc: Build Object for Call.
            * Note:
            *
            */
            build_Params_Call_geRebookingKey: function() {

                var me = this,
                    usersSearchData = this.get_RebookingUsersSearchDataBookingno,
                    params = {
                        idTicketOutwards: [],
                        idTicketReturn: [],
                        identifier: {}
                    };


                me.$toc('>>> rebooking/flightsearchresults/FlightSearchResults.vue >>> build_Params_Call_geRebookingKey');
                params.idOutwardPrice               = this.get_RebookingPriceIdSelectedOutward;
                params.idReturnPrice                = this.get_RebookingPriceIdSelectedReturn;

                params.idTicketOutwards             = this.getRebookingIdTicketOutwards;
                params.idTicketReturn               = this.getRebookingIdTicketReturn;

                params.identifier.bookingCode       = usersSearchData.bookingCode;
                params.identifier.email             = usersSearchData.email;
                params.identifier.idInvoice         = usersSearchData.idInvoice;
                params.identifier.justIdInvoice     = usersSearchData.justIdInvoice;
                params.identifier.lastName          = usersSearchData.lastName;
                params.identifier.modify            = usersSearchData.modify;
                params.identifier.operatorBooking   = usersSearchData.operatorBooking;
                params.identifier.paxBirthDate      = usersSearchData.paxBirthDate;


                return params;

            }, // eo function build_Params_Call_geRebookingKey()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>

    .listing-style3.flight figure span img {
        max-width: 45px !important;
        height: auto;
    }

    .tab-container .tab-content .tab-pane {
        padding: 0px;
    }
    .tab-container .tab-content {
        background: none;
    }
    .tab-container .tab-content .tab-pane .row {
        margin-bottom: 1px;
    }
    .pricing-table {
        padding: 0px;
        padding-top: 15px;
        padding-bottom: 0px;
        background: none;
    }
    .pricing-table {
        padding: 0px;
        padding-top: 15px;
        padding-bottom: 0px;
        background: none;
    }


    .tab-container.style1 ul.tabs li.active > a, .tab-container.style1 ul.tabs li:hover > a {
        color: #fff;
        background: #ab3a7a;
        position: relative;
    }
    .tab-container.style1 ul.tabs.srvcs li.active_rebooking > a, .tab-container.style1 ul.tabs.srvcs li:hover > a {
        color: #fff;
        background: #fdb714;
        position: relative;
    }
    .tab-container.style1 ul.tabs.srvcs li.active_rebooking > a:after, .tab-container.style1 ul.tabs.srvcs li:hover > a:after {
        position: absolute;
        bottom: -5px;
        left: 50%;
        margin-left: -10px;
        border-top: 5px solid #fdb714;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        content: "";
    }

    .icon-check3 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check3:after {
        content: "";
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #AB3B7A;
    }


    .topDistance {
        margin-top: 25px;
    }



    .image-box .discount {
        line-height: 60px;
        text-indent: -16px;
    }


    .icon-check4 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check4:after {
        content: '';
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #FDB714;
    }


    /* Modal */
    .rebooking-error-modal-content {
        padding: 10px;
        font-style: 13px;
        background-color: rgb(255, 255, 255);
    }
    .v--modal-overlay[data-modal="news-modal"] {
        background: rgba(0, 0, 0, 0.5);
        z-index: 555555 !important;
    }
    .demo-modal-class {
        border-radius: 5px;
        background: #F7F7F7;
        box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
    }

</style>